import { forEach } from 'lodash';

export const buildCallSummaryData = summary => {
    const categories = [];
    const answeredCallsData = [];
    const unansweredCallsData = [];
    let maxSum = 0;

    forEach(summary, value => {
        const fromDate = new Date(value.from);

        categories.push(`${fromDate.getDate()}/${fromDate.getMonth() + 1}`);
        answeredCallsData.push(+value.total_calls - +value.unanswered_calls);

        if (+value.unanswered_calls === 0) {
            unansweredCallsData.push("");
        } else {
            unansweredCallsData.push(+value.unanswered_calls);
        }

        const sum = +value.total_calls + +value.unanswered_calls;

        if (sum > maxSum) {
            maxSum = sum
        }
    });

    const series = [{
        name: 'dashboard:answered',
        data: answeredCallsData
    }, {
        name: 'dashboard:unanswered',
        data: unansweredCallsData
    }];

    return {
        categories,
        series,
        maxSum
    };
};
